import _ from'lodash';
import React from "react";
import {Mutation} from "react-apollo";
import queries from "../../queries";
import {withRouter} from "react-router-dom";
import {FormattedMessage} from "react-intl";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import { apolloClient } from '../../config';
import { recordCellAddition } from '../../undoRedo';
import { showToast } from '../../toast';
import { t } from '../../i18n';


// Aide au survol + rangement par famille (aide les nouveaux utilisateurs à s'y retrouver).
const CELL_INFO_KEYS = {
  image: ['content', 'ui.cell.image'],
  text: ['content', 'ui.cell.text'],
  video: ['content', 'ui.cell.video'],
  carousel: ['content', 'ui.cell.carousel'],
  separator: ['content', 'ui.cell.separator'],
  html: ['content', 'ui.cell.html'],
  iframe: ['content', 'ui.cell.iframe'],
  button: ['navigation', 'ui.cell.button'],
  button_diffuse: ['navigation', 'ui.cell.button_diffuse'],
  language_selection: ['navigation', 'ui.cell.language_selection'],
  tab_menu: ['navigation', 'ui.cell.tab_menu'],
  form: ['interaction', 'ui.cell.form'],
  email_form: ['interaction', 'ui.cell.email_form'],
  send_email: ['interaction', 'ui.cell.send_email'],
  products_list: ['info', 'ui.cell.products_list'],
  agendas: ['info', 'ui.cell.agendas'],
  agendas2: ['info', 'ui.cell.agendas2'],
  agenda_tableau: ['info', 'ui.cell.agenda_tableau'],
  products2: ['info', 'ui.cell.products2'],
  batibouw_finder: ['info', 'ui.cell.batibouw_finder'],
  plan: ['info', 'ui.cell.plan'],
  ranking: ['info', 'ui.cell.ranking'],
  memory_game: ['games', 'ui.cell.memory_game'],
  cards_game: ['games', 'ui.cell.cards_game'],
  quizz: ['games', 'ui.cell.quizz'],
  wheel: ['games', 'ui.cell.wheel'],
  jackpot: ['games', 'ui.cell.jackpot'],
  photo: ['photo', 'ui.cell.photo'],
  photobooth: ['photo', 'ui.cell.photobooth'],
  modern_photobooth: ['photo', 'ui.cell.modern_photobooth'],
  photobooth_gif: ['photo', 'ui.cell.photobooth_gif'],
  photobooth_gif2: ['photo', 'ui.cell.photobooth_gif2'],
  photobooth_obs: ['photo', 'ui.cell.photobooth_obs'],
  photobooth_landscape: ['photo', 'ui.cell.photobooth_landscape'],
  photobooth_choice: ['photo', 'ui.cell.photobooth_choice'],
  photobooth_multiple_gif: ['photo', 'ui.cell.photobooth_multiple_gif'],
  givenchy_photobooth: ['photo', 'ui.cell.givenchy_photobooth'],
  johnnie_walker_photobooth: ['photo', 'ui.cell.johnnie_walker_photobooth'],
  haribo_photobooth: ['photo', 'ui.cell.haribo_photobooth'],
  photobooth_stripe_print: ['photo', 'ui.cell.photobooth_stripe_print'],
};
// CELL_INFO[type] = [famille traduite, description traduite]
export const CELL_INFO = Object.keys(CELL_INFO_KEYS).reduce((acc, type) => {
  const [category, descriptionKey] = CELL_INFO_KEYS[type];
  acc[type] = [t(`ui.cat.${category}`), t(descriptionKey)];
  return acc;
}, {});
const CATEGORY_ORDER = ['content', 'navigation', 'interaction', 'info', 'games', 'photo', 'other'].map((c) => t(`ui.cat.${c}`));

class CellToolbox extends React.Component  {

  state = { search: '' };

  render() {
    const { screenType } = this.props;
    const { search } = this.state;
    const { pageId } = this.props.match.params;

    const cellTypes = {
      image: {
        icon: ['far', 'image'],
      },
      text: {
        icon: 'paragraph',
      },
      video: {
        icon: 'film',
      },
      button: {
        icon: 'hand-pointer',
      },
      language_selection: {
        icon: 'language',
      },
      separator: {
        icon: 'arrows-alt-v',
      },
      carousel: {
        icon: ['far', 'images'],
      },
      form: {
        icon: 'clipboard-list',
      },
      tab_menu: {
        icon: 'ellipsis-h',
      },
      products_list: {
        icon: ['far', 'list-alt'],
      },
      memory_game: {
        icon: 'gamepad',
      },
      iframe: {
        icon: 'external-link-alt',
      },
      wheel:{
        icon: 'dharmachakra',
      },
      plan:{
        icon: ["fas", "map"],
      },
      quizz:{
        icon: 'question',
      },
      ranking:{
        icon: 'award'
      },
      /* Icônes : noms Font Awesome 5 (solid par défaut), déjà enregistrées dans icons.js */
      button_diffuse: {
        icon: 'magic',
      },
      agendas: {
        icon: 'calendar-alt',
      },
      agendas2: {
        icon: 'calendar-alt',
      },
      agenda_tableau: {
        icon: 'columns',
      },
      products2: {
        icon: ['far', 'address-card'],
      },
      batibouw_finder: {
        icon: 'search',
      },
      photo: {
        icon: 'camera',
      },
      photobooth: {
        icon: 'camera-retro',
      },
      modern_photobooth: {
        icon: 'mobile-alt',
      },
      photobooth_gif: {
        icon: 'film',
      },
      photobooth_gif2: {
        icon: 'file-video',
      },
      photobooth_obs: {
        icon: 'video',
      },
      photobooth_landscape: {
        icon: 'image',
      },
      jackpot: {
        icon: 'coins',
      },
      cards_game: {
        icon: 'clone',
      },
      photobooth_choice: {
        icon: 'list-ul',
      },
      photobooth_multiple_gif: {
        icon: 'layer-group',
      },
      givenchy_photobooth: {
        icon: 'gem',
      },
      photobooth_stripe_print: {
        icon: 'gem',
      },
      johnnie_walker_photobooth: {
        icon: 'wine-glass',
      },
      haribo_photobooth: {
        icon: 'cookie',
      },
      html: {
        icon: 'code',
      },
      send_email: {
        icon: 'envelope'
      },
    };

    return (
      <Mutation
        mutation={queries.cells.create}
        refetchQueries={() => [{ query: queries.pages.getWithChildren, variables: {id: pageId, screen_type_id: screenType.id} }]}
      >
        {(createCell) => {
          const term = search.trim().toLowerCase();
          const visible = _.pickBy(cellTypes, (d, key) =>
            `${key.replace(/_/g, ' ')} ${(CELL_INFO[key] || [])[1] || ''}`.toLowerCase().includes(term));
          const byCategory = _.groupBy(Object.keys(visible), (key) => (CELL_INFO[key] || [t('ui.cat.other')])[0]);
          return (
            <div>
              <input
                type="search"
                className="tsk-toolbox-search"
                placeholder={t('ui.toolbox.search')}
                value={search}
                onChange={(e) => this.setState({ search: e.target.value })}
              />
              <p className="tsk-toolbox-hint">{t('ui.toolbox.hint')}</p>
              {Object.keys(visible).length === 0 && <p className="tsk-toolbox-hint">{t('ui.toolbox.nomatch', { search })}</p>}
              {CATEGORY_ORDER.filter((c) => byCategory[c]).map((category) => (
                <section key={category} className="tsk-toolbox-category">
                  <h4 className="tsk-toolbox-category__title">{category}</h4>
                  <div className="tsk-toolbox-grid" role="group">
                    {byCategory[category].map((cellType) => (
                      <button
                        type="button"
                        key={cellType}
                        className={'tsk-toolbox-button tsk-button'}
                        title={(CELL_INFO[cellType] || [])[1]}
                        onClick={async () => {
                          const input = { page_id: pageId, cell_type: cellType };
                          const res = await createCell({ variables: { input } });
                          const newId = res && res.data && res.data.createCell && res.data.createCell.id;
                          if (!newId) return;
                          showToast(t('ui.toolbox.added'), 'info', 2500);
                          recordCellAddition({
                            label: t('ui.history.label.add'),
                            cellId: newId,
                            create: async () => (await apolloClient.mutate({ mutation: queries.cells.create, variables: { input } })).data.createCell.id,
                            remove: (id) => apolloClient.mutate({ mutation: queries.cells.deleteCell, variables: { input: id } }),
                          });
                        }}>
                        <div className={'tsk-toolbox-icon'}>
                          <FontAwesomeIcon icon={visible[cellType].icon} />
                        </div>
                        <FormattedMessage id={`page.add.cell.button.${cellType}`} />
                      </button>
                    ))}
                  </div>
                </section>
              ))}
            </div>
          );
        }}
      </Mutation>
    )
  }
}

export default withRouter(CellToolbox);
